<template>
  <div class="rounded h-5 flex px-2 body-4 items-center shrink-0" :class="bg">
    <slot />
  </div>
</template>
<script setup lang="ts">
import { computed } from 'vue'

const props = defineProps<{
  type: 'info' | 'success' | 'warning' | 'error'
}>()

const bg = computed(() => {
  switch (props.type) {
    case 'info':
      return 'bg-[#39C0FE]'
    case 'success':
      return 'bg-[#1FAD9F]'
    case 'warning':
      return 'bg-[#FFB020]'
    case 'error':
      return 'bg-[#FF3B30]'
    default:
      return 'bg-[#39C0FE]'
  }
})
</script>
